export default __webpack_public_path__ + "static/media/whatsappIconWhiteBackground3x.bb713bf4.png";